import type { ProductSetContentDM } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/MultiSectionView.types';

import type { GridCardView } from '../../../Model/ModelTypes';

export const getViewData = (data: ProductSetContentDM) => {
  const result: GridCardView[] = [];

  // 1st card is hero image
  // @ts-expect-error
  result.push({
    id: ['hero', data.productSetId].join('_'),
    key: ['hero', data.productSetId].join('_'),
    imageUrl: data.heroImageUrl,
    isViewHero: true,
  });

  // 2nd card is the text description
  // @ts-expect-error
  result.push({
    id: ['description', data.productSetId].join('_'),
    key: ['description', data.productSetId].join('_'),
    title: data.title,
    body: data.text,
  });

  // rest are the product cards
  data.products.forEach((product) => {
    result.push({
      id: product.id.toString(),
      key: [data.productSetId, 'product', product.id].join('_'),
      imageUrl: product.imageUrl,
      product,
      type: undefined,
    });
  });

  return result;
};
